import { render, staticRenderFns } from "./ConfirmarSenha.vue?vue&type=template&id=d03b0aca"
import script from "./ConfirmarSenha.vue?vue&type=script&lang=js"
export * from "./ConfirmarSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports